import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal } from 'react-bootstrap';

export default class CallListDeletionModal extends React.Component {
  static propTypes = {
    callList: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    shown: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = { newCallListName: null };

  handleDelete = () => {
    axios.delete(
      `/contacts/call_lists/${this.props.callList.id}`
    ).then(() => {
      this.props.onClose(true);
    }).catch(() => {
      this.props.onClose(false);
    });
  }

  render() {
    return (
      <Modal show={this.props.shown} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Call List</Modal.Title>
        </Modal.Header>
        <Modal.Body className="left-buffer-md">
          <div className="bottom-buffer-sm">You are about to delete the following Call List:</div>
          <div><strong>{this.props.callList && this.props.callList.name}</strong></div>
          <div className="top-buffer-sm">This action is permanent. Are you sure you want to delete?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-sm btn-cancel' onClick={this.props.onClose}>Cancel</button>
          <button className='btn btn-sm btn-danger' onClick={this.handleDelete}>Delete Call List</button>
        </Modal.Footer>
      </Modal>
    );
  }
}
